/**
 * @generated SignedSource<<1af3c85f11921a68d919eb93f5011016>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BlockID = {
  blockKey?: string | null;
  id?: string | null;
  noteId?: string | null;
};
export type AcceptDismissPopoverDismissMutation$variables = {
  actionItemIds: ReadonlyArray<BlockID>;
};
export type AcceptDismissPopoverDismissMutation$data = {
  readonly dismissAiActionItems: {
    readonly ok: boolean | null;
  } | null;
};
export type AcceptDismissPopoverDismissMutation = {
  response: AcceptDismissPopoverDismissMutation$data;
  variables: AcceptDismissPopoverDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actionItemIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "actionItemIds",
        "variableName": "actionItemIds"
      }
    ],
    "concreteType": "DismissAiActionItems",
    "kind": "LinkedField",
    "name": "dismissAiActionItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptDismissPopoverDismissMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptDismissPopoverDismissMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "19e9fd446280002104a2e72a214e9b78",
    "id": null,
    "metadata": {},
    "name": "AcceptDismissPopoverDismissMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptDismissPopoverDismissMutation(\n  $actionItemIds: [BlockID!]!\n) {\n  dismissAiActionItems(actionItemIds: $actionItemIds) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "db171b27367cba55c58b61a31cd22ad6";

export default node;
